import { twMerge } from "tailwind-merge";

/**
 * Une clases condicionales y resuelve conflictos de Tailwind.
 *
 * - Los valores falsy (`false | null | undefined`) se descartan, así el
 *   patrón `cond && "clase"` funciona sin ensuciar el output.
 * - `tailwind-merge` deja que la última clase en conflicto gane
 *   (`cn("px-2", "px-4")` → `"px-4"`), lo que permite que un componente
 *   defina defaults y el caller los pise vía `className`.
 *
 * Reemplaza el template-string + ternario repartido por todo el admin.
 */
export function cn(...classes: Array<string | false | null | undefined>): string {
  return twMerge(classes.filter(Boolean).join(" "));
}
